import { Inject, Injectable, InjectionToken } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { RadioSettingsService } from '../services/settings/radio-settings.service';
import { Html5SSOFlowType } from 'estensa-module';
import { ServerRootService } from '../utils/routing/serverroot.service';

export const LOCAL_STORAGE_OPENID_TOKEN_KEY = 'LOCAL_STORAGE_OPENID_TOKEN';
export const LOCATION_TOKEN = new InjectionToken<Location>('LocationToken');

@Injectable({
    providedIn: 'root',
})
export class SsoLoginService {
    constructor(
        @Inject(LOCATION_TOKEN) private location: Location,
        private radioSettings: RadioSettingsService,
        private serverRoot: ServerRootService,
    ) {}

    async login() {
        const settings = await firstValueFrom(this.radioSettings.radioSettingsAsync);

        if (this.hasOpenIdLogin()) {
            return this.logout();
        }

        switch (settings.html5ConfigSettings.html5SsoSettings.flowType) {
            case Html5SSOFlowType.AuthCode:
            case Html5SSOFlowType.AuthCodeWithPkce:
                return this.loginWithAuthCode();
            default:
                throw new Error('Unknown authorization method');
        }
    }

    hasOpenIdLogin() {
        return !!this.getOpenIdToken();
    }

    getOpenIdToken() {
        return localStorage.getItem(LOCAL_STORAGE_OPENID_TOKEN_KEY);
    }

    removeOpenIdToken() {
        localStorage.removeItem(LOCAL_STORAGE_OPENID_TOKEN_KEY);
    }

    setOpenIdToken(token: string) {
        localStorage.setItem(LOCAL_STORAGE_OPENID_TOKEN_KEY, token);
    }

    private async loginWithAuthCode() {
        this.location.href = `${this.serverRoot.getAuthRoot()}/sso/authorize`;
    }

    private logout() {
        const token = this.getOpenIdToken();
        localStorage.removeItem(LOCAL_STORAGE_OPENID_TOKEN_KEY);
        this.location.href = `${this.serverRoot.getAuthRoot()}/sso/logout?oidcToken=${token}`;
    }
}
